document.addEventListener("DOMContentLoaded", function () {
  // CONFIGURATION: Replace these with your theme's specific selectors/keys
  const CONFIG = {
    wishlistButtonSelector: ".bls__product-wishlist-js", // Class of your "Add to Wishlist" button
    localStorageKey: "bls__wishlist-items", // The key your theme uses to save wishlist data
  };
  // ==========================================
  // 1. ADD TO WISHLIST -> REMOVE FROM CART
  // ==========================================
  document.addEventListener("click", function (e) {
    // if(!e.target.closest(CONFIG.wishlistButtonSelector)) return
    const btn = e.target.closest(CONFIG.wishlistButtonSelector);
    const notificationAlert = e.target.closest("cart-notification")?? false;
    // const productVariantId =   btn.dataset.customProductVariantId;
    if(!btn) return;
    // if(!notificationAlert) return;
    const productId = btn.dataset.customIndex ?? btn.dataset.customProductVariantId;   
    if (productId) {
      setTimeout(() => {
        checkAndRemoveFromCart(notificationAlert, productId);
      }, 100);
    }
  });

  // Check this function mostly you don't need it
  function checkAndRemoveFromCart(notification, productId) {
    // 1. Fetch current cart state
    // console.log(window.Shopify.routes.root);
     fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // 2. Find if the product is in the cart
        // Note: Cart items use Variant IDs, but Wishlists usually use Product IDs.
        // We check if the item's product_id matches.
        if(notification){
          const itemInCart = cart.items.find((item) => item.key == productId); // IT works
          console.log(itemInCart);
          if (itemInCart) {
            // 3. Remove from cart
            // removeCartItem(itemInCart.key); // 'key' is unique to the line item
            notification.updateQuantity(productId, 0);
          }
        }else {
        const itemInCart = cart.items.find((item) => item.variant_id == productId); // IT works
          if (itemInCart) {
            // 3. Remove from cart
            // removeCartItem(itemInCart.key); // 'key' is unique to the line item
            const notificationAlert = document.querySelector("cart-notification")?? false;
            console.log(notificationAlert);
            notificationAlert.updateQuantity(productId, 0);
        }
        }
        })
      .catch((err) => console.error("Error fetching cart:", err));
    }


  // ==========================================
  // 2. ADD TO CART -> REMOVE FROM WISHLIST
  // ==========================================
  // ------------------------------------------------------
  // 1. The Network Spy (Fetch Interceptor)
  // This watches for ANY successful add-to-cart action
  // ------------------------------------------------------
  const originalFetch = window.fetch;

  window.fetch = function () {
    return originalFetch.apply(this, arguments).then((response) => {
      // console.log(response);
      // Check if the URL being requested is the Shopify "Add to Cart" URL
      if (response.url.includes("/cart/add")) {
        // Clone the response so we can read the data without breaking the theme
        response
          .clone()
          .json()
          .then((data) => {
            // 'data' contains the product info returned by Shopify
            // If we have a handle, the product was successfully added!
            if (data && data.variant_id) {
              removeFromWishlistStorage(data.variant_id);
            }
          })
          .catch((err) => {
            // Ignore errors (like if the response wasn't JSON)
          });
      }

      return response;
      // return console.log("HERE the error");
    });
  };

  function removeFromWishlistStorage(variantId) {
    // Ensure CONFIG is defined somewhere in your other scripts
    if (typeof CONFIG === "undefined" || !CONFIG.localStorageKey) {
      console.error("CONFIG.localStorageKey is missing");
      return;
    }

    let wishlist =
      JSON.parse(localStorage.getItem(CONFIG.localStorageKey)) || [];

    const initialLength = wishlist.length;

    // Get the Element
    const elBtn = document.querySelector(
      `[data-product-variant-id='${variantId}']`
    );
    const product = elBtn.closest(".bls__product-item");
    const handleToRemove = product.dataset.productHandle;

    // Filter out the item.
    // We convert both to Strings to ensure "123" matches 123
    // 2. Filter the array of Strings
    // Since your wishlist is ["handle-1", "handle-2"], we just compare strings directly.
    wishlist = wishlist.filter((savedHandle) => savedHandle !== handleToRemove);

    // 3. Save back to local storage if something changed
    if (wishlist.length !== initialLength) {
      localStorage.setItem(CONFIG.localStorageKey, JSON.stringify(wishlist));
      console.log("Product handle removed from wishlist:", handleToRemove);

      
      // 4. Update UI
      // We look for any button that has this specific handle data attribute
      const activeHearts = document.querySelectorAll(
        `${CONFIG.wishlistButtonSelector}[data-product-handle="${handleToRemove}"] .bls__product-icon`
      );
      activeHearts.forEach((heart) => {
        heart.classList.remove("active");
        // If your theme uses 'filled' or another class, remove that too:
      });
      // Update the wishlist Icon Numbers
      console.log("from the add to cart functionality");
              BlsWishlistHeader.handleCount();
    }
  }

// Fixing the problem of the Add To Cart button that in the wishlist page
if (window.location.pathname === "/pages/wishlist") {
  document.addEventListener("click", (e) => {
    e.preventDefault();
    if (e.target.closest(".bls__js-addtocart")) {
      const t = e.target.closest(".bls__js-addtocart");
      const variantId = e.target.closest("quick-buy").dataset.productVariantId;
      const n = JSON.parse(localStorage.getItem("bls__wishlist-items"));
      const o = e.target.closest(".bls__product-item").dataset.productHandle;
      BlsSectionProductAddCart.actionAddToCart(t);
      removeFromWishlistStorage(variantId);
      setTimeout(()=>{
      BlsWishlistLoad.init(o, n);
      }, 700);
    }
  });
}
  });

 